/*
 * Decides whether this visitor should download the hero demo at all.
 *
 * The clip is around half a megabyte, and autoplay pulls the whole file down
 * whatever preload says. That is a fair trade on a desktop connection and a
 * poor one on a phone, so the markup ships no src. It is attached here only
 * when the conditions are right, and everyone else keeps the poster, which is
 * about a fiftieth of the weight. Tapping the poster loads it anyway.
 */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function slowConnection() {
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!c) return false;
    if (c.saveData) return true;
    return /(^|-)(2g|3g)$/.test(c.effectiveType || '');
  }

  function shouldAutoload() {
    if (reduce.matches) return false;
    if (window.innerWidth < 750) return false;   // the poster carries it on a phone
    return !slowConnection();
  }

  function attach(video, play) {
    if (!video.getAttribute('src')) {
      var src = video.getAttribute('data-src');
      if (!src) return;
      video.setAttribute('src', src);
    }
    if (!play) return;
    var started = video.play();
    if (started && started.catch) started.catch(function () { /* blocked, poster stands in */ });
  }

  function init(video) {
    if (video.dataset.nbReady) return;
    video.dataset.nbReady = '1';

    if (shouldAutoload()) {
      attach(video, true);
      return;
    }

    // Left on its poster. One tap is enough to change that.
    video.style.cursor = 'pointer';
    video.addEventListener('click', function () { attach(video, true); }, { once: true });

    // A phone turned sideways, or a window pulled wider, becomes a desktop
    var onResize = function () {
      if (shouldAutoload()) {
        window.removeEventListener('resize', onResize);
        attach(video, true);
      }
    };
    window.addEventListener('resize', onResize, { passive: true });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-nb-hero-video]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
